var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefectMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bug_report_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M0,0H26V26H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M22,8.556H18.839a6.683,6.683,0,0,0-2.047-2.178l1.834-1.811L17.039,3,14.6,5.411A6.9,6.9,0,0,0,13,5.222a6.737,6.737,0,0,0-1.586.189L8.961,3,7.375,4.567,9.2,6.378A6.769,6.769,0,0,0,7.161,8.556H4v2.222H6.351a7.287,7.287,0,0,0-.1,1.111V13H4v2.222H6.25v1.111a7.287,7.287,0,0,0,.1,1.111H4v2.222H7.161a6.78,6.78,0,0,0,11.678,0H22V17.444H19.649a7.287,7.287,0,0,0,.1-1.111V15.222H22V13H19.75V11.889a7.287,7.287,0,0,0-.1-1.111H22ZM17.5,13v3.333a4.674,4.674,0,0,1-.079.778l-.113.722-.416.722a4.52,4.52,0,0,1-7.785,0l-.416-.711-.112-.722a4.687,4.687,0,0,1-.079-.789V11.889a4.447,4.447,0,0,1,.079-.778l.112-.722.416-.722a4.577,4.577,0,0,1,1.361-1.456l.641-.433.832-.2A4.31,4.31,0,0,1,13,7.444a4.4,4.4,0,0,1,1.069.133l.765.178.686.467a4.349,4.349,0,0,1,1.361,1.456l.427.722.113.722a4.431,4.431,0,0,1,.079.767V13Zm-6.75,2.222h4.5v2.222h-4.5Zm0-4.444h4.5V13h-4.5Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefectMenu);
export default __webpack_public_path__ + "static/media/defect_menu.e3b5b8706eea8428edf78827ef0045fc.svg";
export { ForwardRef as ReactComponent };